module.exports = __webpack_public_path__ + "img/cleanup3-7-8-2021.1faab4b2.jpg";